<template>
  <v-col cols="12" xl="3" lg="2" class="hidden-md-and-down">{{ currentTime }}</v-col>
</template>

<script>
export default {
  data: () => ({
    currentTime: null,
  }),
  methods: {
    updateTime: function () {
      this.currentTime = this.$moment().format("LTS");
    },
  },
  created() {
    this.currentTime = this.$moment().format("LTS");
    setInterval(() => this.updateTime(), 1 * 1000);
  },
};
</script>